import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import composeClasses from '@mui/utils/composeClasses';
export function getChatMessageSourceUtilityClass(slot) {
  return generateUtilityClass('MuiChatMessageSource', slot);
}
export const chatMessageSourceClasses = generateUtilityClasses('MuiChatMessageSource', ['root', 'index', 'link']);
const slots = {
  root: ['root'],
  index: ['index'],
  link: ['link']
};
export const useChatMessageSourceUtilityClasses = classes => composeClasses(slots, getChatMessageSourceUtilityClass, classes);